export default __webpack_public_path__ + "static/media/TodaysFocus_empty.beaf022e.webp";